import API from '../../../manager/API';
import { dispatch } from '../../hooks';
import slice from './slice';

const { setDataProcessingMergeStatusData } = slice.actions;

const dataProcessingMergeStatus = (url: any) => async () => {
  try {
    const response = await API.dataProcessingMergeStatus.dataProcessingMergeStatus(url);
    dispatch(setDataProcessingMergeStatusData(response.data));
    return { response, status: response.status, data: response.data };
  } catch (error: any) {
    return { status: error.response.status, data: error.response.data };
  }
};

export default {
  dataProcessingMergeStatus
};
